import { ChangeDetectionStrategy, ChangeDetectorRef, Component, HostBinding, Inject, Input, OnChanges } from '@angular/core';

import { ISimpleChanges } from '@frontend/sports/common/core/utils/simple-change';
import { RedirectHelperService } from '@frontend/sports/navigation/core/feature/redirect';
import { OddsDisplayFormat } from '@frontend/sports/types/models/user-settings';
import { Store } from '@ngrx/store';
import { NavigationRouterService } from 'packages/sports/web/app/src/navigation/navigation-router.service';

import {
    BETSLIP_MESSAGES_PROVIDER_INJECTION_TOKEN,
    IBetslipMessagesProviderService,
} from '../../../../base/services/betslip-messages-provider.service';
import { IBetslipRootState } from '../../../../base/store/state';
import { BetslipType } from '../../../../core/betslip-type';
import { BetslipPick } from '../../../../core/picks/betslip-pick';
import BetslipPickActions from '../../../picks/actions';
import BaseBetTypePickComponent from '../../../picks/components/digital/base-bet-type-pick.component';
import BetslipPickUtilsService from '../../../picks/services/betslip-pick-utils.service';
import PickTypeSelectorService from '../../../picks/services/pick-type-selector.service';
import { ITeaserBetPickState, ITeaserBetState } from '../../state';

@Component({
    selector: 'bs-teaser-bet-pick',
    templateUrl: './teaser-bet-pick.component.html',
    styleUrls: ['../../../picks/components/digital/base-bet-type-pick.component.scss', './teaser-bet-pick.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export default class TeaserBetPickComponent extends BaseBetTypePickComponent implements OnChanges {
    @HostBinding('class') className = 'betslip-digital-pick betslip-teaser-bet-pick';

    @Input() override pick: BetslipPick;
    @Input() teaserBetState: ITeaserBetState;
    @Input() oddsDisplayFormat: OddsDisplayFormat;

    optionName: string | undefined;
    teaserPickState: ITeaserBetPickState;
    teaserPointsInfo: {
        currentPoints: string;
        teasedPoints: string;
        newPoints: string;
    };

    readonly betslipType = BetslipType.Teaser;

    constructor(
        store: Store<IBetslipRootState>,
        pickTypeSelector: PickTypeSelectorService,
        @Inject(BETSLIP_MESSAGES_PROVIDER_INJECTION_TOKEN) messageProvider: IBetslipMessagesProviderService,
        navigationRouter: NavigationRouterService,
        redirectHelper: RedirectHelperService,
        changeDetectorRef: ChangeDetectorRef,
        betslipPickUtilsService: BetslipPickUtilsService,
    ) {
        super(store, pickTypeSelector, messageProvider, navigationRouter, redirectHelper, changeDetectorRef, betslipPickUtilsService);
    }

    override ngOnChanges(changes: ISimpleChanges<TeaserBetPickComponent>): void {
        super.ngOnChanges(changes);
        if (changes.teaserBetState || changes.pick) {
            this.teaserPickState = this.teaserBetState.picks[this.pick.id.toString()];
            this.setTeaserPoints();
            this.optionName = this.getOptionName();
            if (this.open) {
                this.pickChangeSubject.next(this.pick);
            }
        }
    }

    override removePick(): void {
        this.store.dispatch(BetslipPickActions.requestRemovePick({ pickId: this.pick.id, eventName: this.pick.eventName.name }));
    }

    private getOptionName(): string {
        return this.teaserPickState.selectedOption?.name || '';
    }

    private setTeaserPoints(): void {
        const currentPoints = this.teaserPickState.oldPoints;
        const selectedPoints = this.teaserBetState.selectedPoints;
        const newPoints = this.teaserPickState.newPoints;
        this.teaserPointsInfo = {
            currentPoints: currentPoints.toString(),
            teasedPoints: selectedPoints.toString(),
            newPoints: newPoints > 0 ? `+${newPoints.toString()}` : newPoints.toString(),
        };
    }
}
